import React from 'react';
import { AlertCircle, Shield, Users, Gift } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

export const RulesAndSpecialsSection = ({ t }) => {
  if (!t.deerRules || !t.groupSpecials) return null;

  return (
    <section id="rules" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Deer Rules */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center mb-4">
              <Shield className="h-12 w-12 text-orange-500" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t.deerRules.title}
            </h2>
            <p className="text-xl text-orange-500 font-semibold">
              {t.deerRules.subtitle}
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {t.deerRules.rules && t.deerRules.rules[0] && (
              <Card className="bg-stone-900 border-orange-500/20 hover:border-orange-500/50 transition-all duration-300">
                <CardHeader>
                  <AlertCircle className="h-10 w-10 text-orange-500 mb-3" />
                  <CardTitle className="text-xl text-orange-500">
                    {t.deerRules.rules[0].title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-300 leading-relaxed">
                    {t.deerRules.rules[0].description}
                  </p>
                </CardContent>
              </Card>
            )}

            {t.deerRules.rules && t.deerRules.rules[1] && (
              <Card className="bg-stone-900 border-orange-500/20 hover:border-orange-500/50 transition-all duration-300">
                <CardHeader>
                  <Shield className="h-10 w-10 text-orange-500 mb-3" />
                  <CardTitle className="text-xl text-orange-500">
                    {t.deerRules.rules[1].title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-300 leading-relaxed">
                    {t.deerRules.rules[1].description}
                  </p>
                </CardContent>
              </Card>
            )}

            {t.deerRules.rules && t.deerRules.rules[2] && (
              <Card className="bg-stone-900 border-orange-500/20 hover:border-orange-500/50 transition-all duration-300">
                <CardHeader>
                  <Users className="h-10 w-10 text-orange-500 mb-3" />
                  <CardTitle className="text-xl text-orange-500">
                    {t.deerRules.rules[2].title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-300 leading-relaxed">
                    {t.deerRules.rules[2].description}
                  </p>
                </CardContent>
              </Card>
            )}
          </div>
        </div>

        {/* Group Specials */}
        <div>
          <div className="text-center mb-12">
            <div className="flex items-center justify-center mb-4">
              <Gift className="h-12 w-12 text-orange-500" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t.groupSpecials.title}
            </h2>
            <p className="text-xl text-orange-500 font-semibold">
              {t.groupSpecials.subtitle}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {t.groupSpecials.specials && t.groupSpecials.specials[0] && (
              <Card className="bg-gradient-to-br from-orange-500/10 to-stone-900 border-orange-500 shadow-lg shadow-orange-500/20">
                <CardHeader>
                  <Users className="h-10 w-10 text-orange-500 mb-3" />
                  <CardTitle className="text-2xl text-orange-500">
                    {t.groupSpecials.specials[0].title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-white text-lg font-semibold">
                    {t.groupSpecials.specials[0].description}
                  </p>
                </CardContent>
              </Card>
            )}

            {t.groupSpecials.specials && t.groupSpecials.specials[1] && (
              <Card className="bg-gradient-to-br from-orange-500/10 to-stone-900 border-orange-500 shadow-lg shadow-orange-500/20">
                <CardHeader>
                  <Gift className="h-10 w-10 text-orange-500 mb-3" />
                  <CardTitle className="text-2xl text-orange-500">
                    {t.groupSpecials.specials[1].title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-white text-lg font-semibold">
                    {t.groupSpecials.specials[1].description}
                  </p>
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
